import * as React from 'react';

import { AmenityBody } from 'components/infosite/amenities/internals/amenity-body';
import { AmenityDescription } from 'components/infosite/amenities/amenity-description';
import { AmenitySection } from 'components/infosite/amenities/amenity-section';

export const renderAmenityBody = (text, index, category) => {
  if (text.length && text.length > 0) {
    return <AmenityBody key={`${category}-${index}`} text={text} index={index} category={category} />;
  }
};

export const renderAmenityDescription = (section, index, category) => {
  if ((section.body && section.body.length > 0) || (section.descriptions && section.descriptions.length > 0)) {
    return <AmenityDescription key={`amenity-description__${category}-${index}`} section={section} index={index} category={category} />;
  }
};

export const renderAmenitySection = (section, index, category) => {
  if (section.title && section.body && section.body.length > 0) {
    return <AmenitySection key={`amenity-section__${category}-${index}`} section={section} index={index} category={category} />;
  }
};

export const renderAlternativeNames = section => section && <li key={section.value}>{section.value}</li>;
